import { Reducer } from "react";

import { LayoutResult } from '../../service/ServiceAPI';

// ----------------------------------------------------------
// LayoutOutput
export type LayoutOutputState = {
    isInvalid: boolean,
    layoutOutput?: LayoutResult[]
}

const initialLayoutOutputState: LayoutOutputState = {
    isInvalid: false,
    layoutOutput: []
}

type UpdateOutputAction = {
    type: String,
    payload: LayoutOutputState
}

export function updateLayoutOutputAction(payload: LayoutOutputState) {
    return { type: "DO_UPDATE_OUTPUT", payload: payload }
};

export function updateInvalidateAction(payload: LayoutOutputState) {
    return { type: "DO_UPDATE_INVALID", payload: payload }
};

const layoutOutputReducer: Reducer<LayoutOutputState, UpdateOutputAction> = (state: LayoutOutputState = initialLayoutOutputState, action: UpdateOutputAction | any) => {
    switch(action.type) {
        case 'DO_UPDATE_OUTPUT':   // update redux with new output data, i.e. we did a RESTful request leading to new layout results
            return { isInvalid: false, layoutOutput: action.payload.layoutOutput }
            //return {
            //    ...state, layoutOutput: [ ...state.layoutOutput, ...action.payload.layoutOutput ]
            //};
        case 'DO_UPDATE_INVALID':  // update the isInvalid state in the redux store, i.e. we changed an input value and the output is not longer valid
            return {
                ...state, isInvalid: action.payload.isInvalid
            };
        default: 
            return state;
    }
}

export default layoutOutputReducer;
